import Popover from '../popover/popover';
import ProgressBar from '../../../commons/components/progressbar/Progressbar';
import ActionsApply from '../../../commons/components/actions-apply/Actions-apply';
import logo from '../../../images/logo-header.svg';
import iconDownlaod from '../../../images/downloadQuestions.svg';
import './header.scss';

interface IHeader {
    isOnlyLogo?: boolean;
    title?: string;
    isOnlyHeader?: boolean;
    initLoading?: boolean;
    name: string;
    progress: string | number;
}

const Header = (props: IHeader) => {
    const { isOnlyLogo, title, isOnlyHeader, initLoading, name, progress } =
        props;
    const handleBackLanding = () => {
        window.open('https://rpp.pe/empresasquetransforman', '_self');
    };

    return (
        <div
            className="Header"
            style={{
                backgroundImage:
                    'url(/images/header.jpg)',
            }}
        >
            <header className="HeaderInner">
                <nav className="HeaderNav">
                    <h1 className="HeaderLogo">
                        <img
                            src={logo}
                            alt="Empresas que transforman el Perú"
                            onClick={handleBackLanding}
                        />
                    </h1>
                    <div className="separate"></div>
                    {!isOnlyLogo && (
                        <div className="HeaderItems">
                            <span className="separates"></span>
                            <Popover name={name}></Popover>
                        </div>
                    )}
                </nav>
                <div className="HeaderTitles">
                    {!initLoading && <h2>{title}</h2>}
                </div>
                {!isOnlyHeader && (
                    <div className="HeaderActionsBar">
                        <div className="HeaderBar">
                            {!initLoading && (
                                <ProgressBar progress={progress}></ProgressBar>
                            )}
                            <div className="HeaderBarDownload">
                                <a
                                    href="/doc/preguntas.docx"
                                    download="Preguntas"
                                >
                                    <img
                                        src={iconDownlaod}
                                        alt="Empresas que transforman el Perú"
                                    />{' '}
                                    Descargar Preguntas
                                </a>
                            </div>
                        </div>
                        <div className="separate"></div>
                        <div className="HeaderActions">
                            {!initLoading && <ActionsApply></ActionsApply>}
                        </div>
                    </div>
                )}
            </header>
        </div>
    );
};

export default Header;
